const sunCalc = (value) => {
    return {
        type: 'SUN_CALC',
        data: value
    };
}
export default sunCalc;